import { Input } from "antd";
import { LabelledElement } from ".";

export const LabelledInput = ({ label, type, ...props }) => {
  const handleChange = (event) => {
    let inputValue = event.target.value;
    if (props.inputType === 'float') {
      // remove invalid chars, allow only digits and one dot
      inputValue = inputValue.replace(/[^0-9.]/g, "");

      // handle multiple dots: keeping first only
      const dotIndex = inputValue.indexOf(".");
      if (dotIndex !== -1) {
        inputValue = inputValue.slice(0, dotIndex + 1) + inputValue.slice(dotIndex + 1).replace(/\./g, "");
      }
    }

    if (props.inputType === 'int') {
      // remove invalid chars, allow only digits
      inputValue = inputValue.replace(/[^0-9]/g, "");
      // remove leading zeros
      inputValue = inputValue.replace(/^0+/, "");
    }

    if (type === 'float-calc') {
      // allow only digits, dot, and plus
      inputValue = inputValue.replace(/[^0-9.+]/g, "");
      const match = inputValue.match(/^(\d*\.?\d+)\+(\d*\.?\d+)$/);
      setTimeout(() => {
        // evaluate only if it's a valid simple addition expression (e.g., 9.5+11.2)
        if (match) {
          const left = parseFloat(match[1]);
          const right = parseFloat(match[2]);
          const result = left + right;
          props.onChange(result);
        }
      }, 1500);
    }

    if (type === 'int-calc') {
      // allow only digits and plus
      inputValue = inputValue.replace(/[^0-9+]/g, "");
      setTimeout(() => {
        // evaluate only if it's a valid simple addition expression (e.g., 9+11)
        const match = inputValue.match(/^(\d+)\+(\d+)$/);
        if (match) {
          const left = parseInt(match[1], 10);
          const right = parseInt(match[2], 10);
          const result = left + right;
          props.onChange(result);
        }
      }, 1500);
    }

    if (props.passEvent) {
      props.onChange(event);  // pass event
    } else {
      props.onChange(inputValue);  // pass formatted or original value
    }
  };

  return (
    <LabelledElement label={label} type={type}>
      <Input {...props} variant="filled" onChange={handleChange} />
    </LabelledElement>
  )
};
